import { createFileRoute } from '@tanstack/react-router';

import { GlobalEventsPage } from '@/pages/admin/global-events/GlobalEventsPage';

export const Route = createFileRoute('/admin/_admin/global-events')({
  component: GlobalEventsPage
});
